import { PORT, INTL_URL } from 'const';
const punycode = require('punycode');

export const getSubdomainUrl = (code: string, isProduction: boolean) =>
  isProduction
    ? `https://${punycode.toASCII(code)}.${INTL_URL}/`
    : `http://${punycode.toASCII(code)}.localhost:${PORT}`;
